module.exports = __webpack_public_path__ + "static/media/xbert_avatar.a894e4bc.png";